export default {
    data: () => ({
        myMap: null,
    }),
    methods: {
        initMap(datumName = 'wrapForm') {
            let vm = this;

            let placemark, center = [55.748144, 37.623201];

            vm.myMap = new window.ymaps.Map("map", {
                center: center,
                zoom: 15,
                controls: ['geolocationControl', 'routeEditor', 'typeSelector']
            });

            vm.myMap.behaviors.disable('scrollZoom');

            if (vm[datumName].latitude && vm[datumName].longitude) {
                placemark = new window.ymaps.Placemark([ vm[datumName].latitude, vm[datumName].longitude ], {
                    balloonContent: '',
                    balloonCloseButton: false,
                    hideIconOnBalloonOpen: false
                });

                vm.myMap.geoObjects.add(placemark);

                vm.myMap.setCenter([ vm[datumName].latitude, vm[datumName].longitude ]);
            }

            vm.myMap.events.add('click', function (e) {
                let coords = e.get('coords');

                let obj = vm.myMap.geoObjects.get(0);

                if (obj) {
                    vm.myMap.geoObjects.remove(obj);
                }

                vm[datumName].latitude = coords[0].toPrecision(8);
                vm[datumName].longitude = coords[1].toPrecision(8);

                placemark = new window.ymaps.Placemark([vm[datumName].latitude, vm[datumName].longitude], {
                    balloonContent: '',
                    balloonCloseButton: false,
                    hideIconOnBalloonOpen: false
                });

                vm.myMap.geoObjects.add(placemark);
            });

            vm.myMap.container.fitToViewport();
            /* поиск по карте от Яндекса, без информативного попапа на карте */
            let searchControl = new ymaps.control.SearchControl({
                options: {
                    noPlacemark: true
                }
            });

            vm.myMap.controls.add(searchControl);
            vm.myMap.controls.add('zoomControl');
        },
        removeAllMark() {
            this.myMap.geoObjects.removeAll();
        },
        addMaker(latitude, longitude, content = '') {
            let placemark = new window.ymaps.Placemark([latitude, longitude ], {
                balloonContent: content,
                balloonCloseButton: false,
                hideIconOnBalloonOpen: false
            });

            this.myMap.geoObjects.add(placemark);
        },
        setCenter(latitude, longitude, zoom = 15) {
            this.myMap.setCenter([latitude, longitude], zoom);
        }
    },
};
